import {PaperContainer} from "base/ui/containers";
import {FormContainer} from "base/form/components";
import {PermitApplicationBillingFields} from "permitapplication/presentational/form";
import {PermitExtensionFeesFormFields, PermitExtensionForm} from "./form";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const PermitExtensionFeesContent = ({extension, isStepEditable, onFormSubmit}) => {
    return (
        <Stack direction="row" spacing={1}>
            <FormContainer>
                <Typography variant="h6" gutterBottom mt={2} ml={2}>
                    Prorrogação
                </Typography>
                <PermitExtensionForm entity={extension} onSubmit={onFormSubmit}>
                    <PermitExtensionFeesFormFields
                        extension={extension}
                        disabled={!isStepEditable}
                    />
                </PermitExtensionForm>
            </FormContainer>
            <PaperContainer>
                <Typography variant="h6" gutterBottom>
                    Autorização original
                </Typography>
                <PermitApplicationBillingFields permit={extension?.permit} fullWidth />
            </PaperContainer>
        </Stack>
    );
};

export default PermitExtensionFeesContent;
